import { CasStackRow } from 'src/compass/shared/components';
import CasLink2 from 'src/compass/shared/components/CasLink/CasLink2';
import formatPhoneNumber from 'src/compass/shared/util/formatPhoneNumber';

interface IProps {
  value: string;
  suffix?: string | null;
}

export function RenderContactsPhone({ value, suffix }: IProps) {
  const linkPhone = value?.replace(/[^a-zA-Z0-9+]/g, '');

  if (!linkPhone) return null;

  return (
    <CasStackRow>
      <CasLink2 href={`tel:${linkPhone}`} icon="ic:baseline-phone" />
      <CasLink2 href={`sms:${linkPhone}`} icon="fa7-solid:sms" />

      <span>
        {formatPhoneNumber(value)} {suffix && <i>{suffix}</i>}
      </span>
    </CasStackRow>
  );
}
